<template>
    <div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div v-if="loading" class="mg-t-20">
            <spinner-component :loading="loading"/>
        </div>

        <div v-if="error" class="mg-t-20 tx-center tx-danger">
            {{ error }}
        </div>

        <div v-else class="row justify-content-center">
            <div class="col-lg-9 pd-x-0">
                <div v-if="!message && !loading">
                    <h5 class="tx-color-01 mg-b-5 tx-center">No message found.</h5>
                    <p class="tx-color-03 tx-13 tx-center">It seems this message does not exist anymore.</p>
                </div>

                <div v-if="message" class="mail-content">
                    <div class="mail-content-header">
                        <div class="media">
                            <div class="avatar avatar-sm">
								<span v-if="message.type === 'receive'" class="avatar-initial rounded-circle bg-warning">IC</span>
								<img v-else :src="message.client_details.avatar" class="rounded-circle" alt="">
							</div>
                            <div class="media-body mg-l-10">
                                <h6 class="mg-b-2 tx-13">
                                    {{ (message.type === 'receive') ? 'Cash' : 'You' }}
                                </h6>
                                <span class="d-block tx-11 tx-color-03">{{ messageDate }}</span>
                            </div>
                        </div>
                        <nav class="nav nav-icon-only mg-l-auto">
							<router-link class="nav-link" :to="{ name: (message.type === 'receive') ? 'messages.inbox' : 'messages.sent' }">Go Back</router-link>
						</nav>
                    </div>
                    <div class="mail-content-body ps">
                        <div class="pd-20 pd-lg-25 pd-xl-30 mt-5">
                            <h5 class="mg-b-30">
                                <p class="tx-color-03 tx-11 mg-b-0">{{ message.subject }}</p>
                                {{ message.topic }}
                            </h5>

                            <p class="tx-color-03">{{ message.message }}</p>
                            
                            <p v-if="message.type === 'receive'">
                                <span>Kind regards,</span><br>
                                <strong></strong>
                            </p>
                        </div>
						<div class="pd-20 pd-lg-25 pd-xl-30 pd-t-0-f" v-if="isCommentable">
							<comments-component :comments="message.comments"/>
						</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
	.mail-content {
		position: initial;
		top: 0;
		left: 0;
		bottom: 0;
		width: auto;
		background-color: #f5f6fa;
	}

	.mail-content-header {
		background-color: #fff;
		position: absolute;
		top: 0;
		left: 15px;
		right: 15px;
		height: 55px;
		border-bottom: 1px solid rgba(72, 94, 144, 0.16);
		padding: 0 20px;
		display: flex;
		align-items: center;
	}

	.mail-content-body {
		position: initial;
		background-color: #fff;
		top: 55px;
		left: 0;
		right: 0;
		bottom: 0;
	}
</style>

<script>
	export default {
		mounted() {},
		data() {
			return {
				loading: false,
				message: null,
				error: null
			};
		},
		created() {
			this.fetchMessage();
		},
		computed: {
			messageDate() {
				return moment(
					this.message.created_at,
					"YYYY-MM-DD hh:mm:ss"
				).calendar(null, {
					sameDay: "[Today] [at] LT",
					lastDay: "[Yesterday] [at] LT",
					lastWeek: "[Last] dddd [at] LT",
					sameElse: "MMMM D YYYY [at] LT"
				});
			},
			isCommentable() {
				return (
					this.message.type === "send" &&
					!_.isEmpty(this.message.external_client_id)
				);
			}
		},
		watch: {
			$route: "fetchMessage",
			"message.status": function(status) {
				if (status === "unread") {
					this.markAsRead();
				}
			}
		},
		methods: {
			markAsRead() {
				axios.patch(`/api/messages/${this.$route.params.id}`, {
					status: "read"
				});
			},
			fetchMessage() {
				this.error = this.message = null;
				this.loading = true;

				axios
					.get(`/api/messages/${this.$route.params.id}`)
					.then(response => {
						this.message = response.data.data.messages;
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;
					});
			}
		}
	};
</script>
